import {
  Body1,
  ColorClass,
  ColorValue,
  FontClass,
  Header1,
  Header2,
  LinkIcon,
  NavItem,
  PageBody,
  TextButton,
  TextButtonTheme,
} from "ui";
import { PageWithHeaderAndFooter } from "@web/components/containers/PageWithHeaderAndFooter";
import { CameraData } from "@web/types/CameraData";
import Image from "next/image";
import styles from "./css/CameraPage.module.css";
import { imageDimensionsFromUrl } from "@web/utils/camera/imageDimensionsFromUrl";
import { CameraDetails } from "@web/components/camera/CameraDetails";

function CameraDetailsSection({ cameraData }: { cameraData: CameraData }) {
  return (
    <div className={styles.cameraDetailsSection}>
      <Header2 colorClass={ColorClass.Primary}>Camera Details</Header2>
      <CameraDetails cameraData={cameraData} isSingleColumn={false} />
    </div>
  );
}

function CompareSection({
  cameraData: _cameraData,
}: {
  cameraData: CameraData;
}) {
  return (
    <div className={styles.compareSection}>
      <NavItem
        colorClass={ColorClass.Primary}
        textAlign="center"
        textTransform="uppercase"
      >
        Compare to other cameras
      </NavItem>
    </div>
  );
}

function TopSection({ cameraData }: { cameraData: CameraData }) {
  const imageDimensions = imageDimensionsFromUrl(cameraData["Link to Image"]);

  const left = (
    <div>
      <Header1 colorClass={ColorClass.Primary} textAlign="left">
        {cameraData["Camera Name"]}
      </Header1>
      <Body1 className={styles.description} colorClass={ColorClass.Primary}>
        {cameraData["Description"]}
      </Body1>
      <TextButton
        buttonThemeOrColorClass={TextButtonTheme.Primary}
        className={styles.manual}
        fontClass={FontClass.Header3}
        href={cameraData["Link to Manual"]}
        icon={<LinkIcon colorValue={ColorValue.Primary} />}
        textTransform="uppercase"
        type="link_external"
      >
        {cameraData["Camera Name"]} manual
      </TextButton>
    </div>
  );

  const right = (
    <div
      className={styles.imageContainer}
      style={{ backgroundColor: cameraData["Color"] }}
    >
      <Image
        alt={cameraData["Camera Name"]}
        className={styles.image}
        height={imageDimensions.height}
        src={cameraData["Link to Image"]}
        style={{ objectFit: "contain" }}
        width={imageDimensions.width}
      />
    </div>
  );

  return (
    <div className={styles.topSection}>
      {left}
      {right}
    </div>
  );
}

type Props = {
  cameraData: CameraData;
};

export function CameraPage({ cameraData }: Props) {
  return (
    <PageWithHeaderAndFooter>
      <div>
        <PageBody hasHorizontalPadding>
          <TopSection cameraData={cameraData} />
          <CompareSection cameraData={cameraData} />
          <CameraDetailsSection cameraData={cameraData} />
        </PageBody>
      </div>
    </PageWithHeaderAndFooter>
  );
}
